<h4 mat-dialog-title [innerHTML]="title"></h4>

<div mat-dialog-content>
  <p [innerHTML]="message"></p>
  <div style="margin-bottom: 10px;" fxLayout="row" fxLayoutGap="10px">
    <button type="button" mat-raised-button
    (click)="dialogRef.close(true)">{{okText}}</button>
    @if (!defaultCancel) {
      <button type="button" mat-raised-button
      (click)="dialogRef.close()">{{ cancelText }}</button>
    }
    @if (defaultCancel) {
      <button type="button" cdkFocusRegionstart mat-raised-button
      (click)="dialogRef.close()">{{ cancelText }}</button>
    }
  </div>
</div>
